import { render } from "./CouponExportModal.vue?vue&type=template&id=0e872445&scoped=true"
import script from "./CouponExportModal.vue?vue&type=script&lang=js"
export * from "./CouponExportModal.vue?vue&type=script&lang=js"

import "./CouponExportModal.vue?vue&type=style&index=0&id=0e872445&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e872445"]])

export default __exports__